import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import SEOHead from "./components/SEOHead";
import Analytics from "./components/Analytics";
import V2Layout from "./v2/V2Layout";
import V2Home from "./v2/pages/V2Home";
import V2About from "./v2/pages/V2About";
import V2Consultancy from "./v2/pages/V2Consultancy";
import V2Contact from "./v2/pages/V2Contact";
import V2Industries from "./v2/pages/V2Industries";
import V2Investors from "./v2/pages/V2Investors";
import V2InvestorRequestAccess from "./v2/pages/V2InvestorRequestAccess";
import V2InvestorLogin from "./v2/pages/V2InvestorLogin";
import { V2InvestorPortal, V2InvestorOverview, V2InvestorSection } from "./v2/pages/V2InvestorPortal";

import V2VideraHealthcare from "./v2/pages/V2VideraHealthcare";
import V2VideraHardServices from "./v2/pages/V2VideraHardServices";
import V2VideraConstruction from "./v2/pages/V2VideraConstruction";
import V2VideraPM from "./v2/pages/V2VideraPM";
import V2VideraVanguard from "./v2/pages/V2VideraVanguard";
import V2HandbackReadiness from "./v2/pages/V2HandbackReadiness";
import V2InternationalP3 from "./v2/pages/V2InternationalP3";
import V2Firestopping from "./v2/pages/V2Firestopping";
import V2SafeTrace from "./v2/pages/V2SafeTrace";
import V2FirestoppingDashboard from "./v2/pages/V2FirestoppingDashboard";

// Insights (Resources renamed per brief)
import V2Resources from "./v2/pages/V2Resources";
import V2ResourceArticle from "./v2/pages/V2ResourceArticle";
import V2ResourceCluster from "./v2/pages/V2ResourceCluster";

import AdminApp from "./v2/admin/AdminApp";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SEOHead />
        <Analytics />
        <Routes>
          {/* Admin (dark chrome, outside marketing layout) */}
          <Route path="/admin/*" element={<AdminApp />} />

          <Route path="/" element={<V2Layout />}>
            <Route index element={<V2Home />} />

            {/* Videra product pages */}
            <Route path="videra/healthcare"      element={<V2VideraHealthcare />} />
            <Route path="videra/hard-services"   element={<V2VideraHardServices />} />
            <Route path="videra/construction"    element={<V2VideraConstruction />} />
            <Route path="videra/pm"              element={<V2VideraPM />} />
            <Route path="videra/vanguard"        element={<V2VideraVanguard />} />

            {/* PFI / P3 */}
            <Route path="handback-readiness"     element={<V2HandbackReadiness />} />
            <Route path="international-p3"       element={<V2InternationalP3 />} />

            {/* Firestopping */}
            <Route path="firestopping"                       element={<V2Firestopping />} />
            <Route path="firestopping/safetrace"             element={<V2SafeTrace />} />
            <Route path="firestopping/business-dashboard"    element={<V2FirestoppingDashboard />} />

            {/* Solutions overview = firestopping-style hub */}
            <Route path="solutions" element={<Navigate to="/videra/healthcare" replace />} />

            {/* Company / navigation pages */}
            <Route path="industries"   element={<V2Industries />} />
            <Route path="consultancy"  element={<V2Consultancy />} />
            <Route path="about"        element={<V2About />} />
            <Route path="contact"      element={<V2Contact />} />

            {/* Insights (was /resources) */}
            <Route path="insights"                   element={<V2Resources />} />
            <Route path="insights/topic/:cluster"    element={<V2ResourceCluster />} />
            <Route path="insights/:slug"             element={<V2ResourceArticle />} />
            {/* Legacy resources redirects */}
            <Route path="resources"                  element={<Navigate to="/insights" replace />} />
            <Route path="resources/topic/:cluster"   element={<Navigate to="/insights/topic/:cluster" replace />} />
            <Route path="resources/:slug"            element={<Navigate to="/insights/:slug" replace />} />

            {/* Investors (footer-only, noindex) */}
            <Route path="investors"                       element={<V2Investors />} />
            <Route path="investors/request-access"        element={<V2InvestorRequestAccess />} />
            <Route path="investors/login"                 element={<V2InvestorLogin />} />

            {/* Legacy path redirects */}
            <Route path="platform"                  element={<Navigate to="/videra/healthcare" replace />} />
            <Route path="sectors"                   element={<Navigate to="/industries" replace />} />
            <Route path="sectors/healthcare"        element={<Navigate to="/videra/healthcare" replace />} />
            <Route path="sectors/nhs"               element={<Navigate to="/videra/healthcare" replace />} />
            <Route path="sectors/hard-services"     element={<Navigate to="/videra/hard-services" replace />} />
            <Route path="sectors/construction"      element={<Navigate to="/videra/construction" replace />} />
            <Route path="sectors/:slug"             element={<Navigate to="/industries" replace />} />
            <Route path="videra"                    element={<Navigate to="/videra/pm" replace />} />
            <Route path="services"                  element={<Navigate to="/consultancy" replace />} />

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>

          {/* Investor Portal — separate layout, outside marketing site */}
          <Route path="/investors/portal" element={<V2InvestorPortal />}>
            <Route index element={<V2InvestorOverview />} />
            <Route path=":section" element={<V2InvestorSection />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
